<template>
	<input autocomplete="off" :id="element.attributes.id" :style="element.styles"
		:placeholder="inputPlaceholder" @keyup.enter="doKeyUpAction(element)" />
</template>

<script lang="ts">
import { Container } from "@/types/customPage";
import { defineComponent, PropType } from "vue";
import { doActionHelper } from "@/utils/action";
import { isPhoneInputAttributes } from "@/utils/phoneNumber";

export default defineComponent({
	props: {
		element: {
			type: Object as PropType<Container>,
			required: true,
		},
	},
	computed: {
		inputPlaceholder(): string | undefined {
			return isPhoneInputAttributes(this.element.attributes)
				? "Phone"
				: this.element.attributes.placeholder;
		},
	},
	methods: {
		doAction(container: Container) {
			doActionHelper(container);
		},
		doKeyUpAction(container: Container) {
			doActionHelper(container, true)
		},
	},
});
</script>

<style scoped lang="scss"></style>
